import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';

import HeroCard from '../elements/HeroCard';

import vw from 'styles/utils';
import media from 'styles/media';

// import { getLatestArticle } from 'utils/request';
// import { getLatestArticle, getPopularArticle } from 'utils/request';
import hero from 'data/hero';
import latestArticle from 'data/latestArticle';

function Hero() {
  const [imagesIndex, setImagesIndex] = useState([])
  // const [latestArticle, setLatestArticle] = useState({})
  // const [featureNews, setFeatureNews] = useState({})
  // const [latestArticleFromAPI, setLatestArticleFromAPI] = useState('empty')

  // useEffect(() => {
    // async function fetchData() {
      // const featureNews = await getFeatureNews();
      // const tmpLatestArticleFromAPI = await getLatestArticle();
      
      // setFeatureNews(featureNews)
      // setLatestArticleFromAPI(tmpLatestArticleFromAPI)
      // console.log("tmpLatestArticleFromAPI = ", tmpLatestArticleFromAPI)
    // }
    // fetchData();
  // }, [])

  // useEffect(() => {
  //   async function fetchData() {
  //     const latestArticle = await getLatestArticle();
  //     setLatestArticle(latestArticle.ArticleList)
  //   }
  //   fetchData();
  // }, [])
  useEffect(() => {
    let tmpImagesIndex = [];
    let indexPool = Array.from(Array(16).keys()); // [0, 1, 2 ... 14, 15]

    for(let i=0; i<3; i++) {
      let index = Math.floor((Math.random() * indexPool.length));
      tmpImagesIndex.push(indexPool[index]);
      indexPool.splice(index, 1);
      // console.log(index, tmpImagesIndex)
    }
    
    setImagesIndex(tmpImagesIndex)
    // console.log(tmpImagesIndex)
  }, [])
  
  return (
    <Root>
      <NewsRow>
        <ColumnLeft>
          <HeroCard
            imgUrl={hero[imagesIndex[0]]}
            title={latestArticle.ArticleList[0].title}
            author={latestArticle.ArticleList[0].author}
            url={latestArticle.ArticleList[0].url}
            time={latestArticle.ArticleList[0].time}
            label="熱門點閱"
          />
        </ColumnLeft>
        <ColumnRight>
          <HeroCard
            imgUrl={hero[imagesIndex[1]]}
            title={latestArticle.ArticleList[1].title}
            author={latestArticle.ArticleList[1].author}
            url={latestArticle.ArticleList[1].url}
            time={latestArticle.ArticleList[1].time}
            label="最新產出"
          />
          <HeroCard
            imgUrl={hero[imagesIndex[2]]}
            title={latestArticle.ArticleList[2].title}
            author={latestArticle.ArticleList[2].author}
            url={latestArticle.ArticleList[2].url}
            time={latestArticle.ArticleList[2].time}
            label="最新產出"
          />
        </ColumnRight>
      </NewsRow>
    </Root>
  )
}

const Root = styled.section`
  /* ${vw('margin-bottom', 20, 30)} */
`;

const NewsRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  column-gap: 24px;

  ${vw('height', 500, 370, 568)}
  ${vw('margin-bottom', 15, 30)}

  @media ${media.tablet} {
    flex-direction: row;
  }

  ${vw('column-gap', 10, 16, 24)}
`;

const ColumnLeft = styled.div`
  width: 100%;
  height: 33%;

  @media ${media.tablet} {
    width: 60%;
    height: 100%;
  }

  @media ${media.desktop} {
    width: 65%;
  }

  ${vw('margin-bottom', 10, 0)}
`;

const ColumnRight = styled.div`
  width: 100%;
  height: 67%;
  display: flex;
  flex-direction: column;

  @media ${media.tablet} {
    width: 40%;
    height: 100%;
  }

  @media ${media.desktop} {
    width: 35%;
  }

  ${vw('row-gap', 10, 16, 24)}
`;

export default Hero
